import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_URL;

axios.defaults.baseURL = BACKEND_URL;
axios.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
};

type Response = {
  error: boolean;
  message?: unknown;
  data?: unknown;
};

const getToken = (): string | undefined => {
  const tokenString = sessionStorage.getItem('token');
  const token = tokenString !== null ? atob(tokenString) : undefined;

  return token;
};

export class WashCycleService {
  static async addWashCycle(clothesCode: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .post(
          '/v1/washcycle',
          { clothesCode },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }
}
